export function isBlank(value) {
    return !value || !value.replace(/\s/g, '').length;
}